import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, CheckCircle2 } from 'lucide-react';
export function Tomos() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const tomos = [{
    id: 1,
    icon: '📖',
    color: 'bg-blue-500',
    border: 'border-blue-500',
    lightBg: 'bg-blue-50',
    title: 'El Código del Fútbol Femenino',
    subtitle: 'La guía definitiva para entender a la jugadora moderna',
    description: 'Todo lo que necesitás saber para entrenar mujeres con criterio, ciencia y resultados reales.',
    bullets: ['Diferencias fisiológicas mujer vs hombre en el deporte', 'Ciclo menstrual y rendimiento deportivo', 'Psicología de la jugadora femenina', 'Cómo crear vínculos de confianza con el plantel', 'Errores más comunes al trasladar metodología masculina al fútbol femenino', 'El nuevo perfil del entrenador/a de fútbol femenino', 'Cómo adaptar la carga según el estado hormonal del plantel', 'Lesiones más frecuentes en la mujer futbolista y cómo prevenirlas']
  }, {
    id: 2,
    icon: '📅',
    color: 'bg-purple-500',
    border: 'border-purple-500',
    lightBg: 'bg-purple-50',
    title: 'Planificación Anual Sin Errores',
    subtitle: 'Sistema completo de periodización para equipos femeninos',
    description: 'Dejá de arrancar cada semana desde cero. Toda la temporada estructurada y lista para ejecutar.',
    bullets: ['Cómo armar un macrociclo, mesociclo y microciclo real', 'Planificación según categorías: infantil, juvenil y adulta', 'Cómo adaptar la carga según el ciclo menstrual del plantel', 'Modelo de temporada completa lista para usar', 'Gestión de cargas con plantel reducido', 'Cómo planificar con poco tiempo de entrenamiento semanal', 'Periodización táctica aplicada al fútbol femenino', 'Control de cargas y recuperación activa']
  }, {
    id: 3,
    icon: '💪',
    color: 'bg-red-500',
    border: 'border-red-500',
    lightBg: 'bg-red-50',
    title: 'Preparación Física Específica',
    subtitle: 'Entrenamiento funcional diseñado exclusivamente para la mujer futbolista',
    description: 'El cuerpo de la mujer no es un hombre más pequeño. Entrenalo con la metodología correcta.',
    bullets: ['Trabajo de fuerza adaptado a la mujer futbolista', 'Prevención de lesiones específicas: rodilla, tobillo y cadera', 'Velocidad, agilidad y coordinación específica para el fútbol femenino', 'Resistencia aeróbica y anaeróbica dentro del campo', '+40 ejercicios físicos con descripción completa', 'Cómo integrar el trabajo físico con pelota dentro del campo', 'Tests de evaluación física adaptados a la mujer', 'Recuperación post-partido y microciclo semanal']
  }, {
    id: 4,
    icon: '⚽',
    color: 'bg-emerald-500',
    border: 'border-emerald-500',
    lightBg: 'bg-emerald-50',
    title: 'Táctica y Sistema de Juego',
    subtitle: 'Cómo construir un equipo ganador desde cero',
    description: 'Los sistemas más efectivos del fútbol femenino actual, explicados paso a paso para cualquier nivel de plantel.',
    bullets: ['Los sistemas más efectivos para el fútbol femenino actual', 'Cómo enseñar conceptos tácticos a jugadoras de todos los niveles', 'Organización defensiva y ofensiva paso a paso', 'Transiciones, pressing y salida limpia de balón', 'Cómo adaptar la táctica al nivel real del plantel', '+30 situaciones tácticas explicadas con diagramas', 'Juego posicional aplicado al fútbol femenino', 'Cómo corregir tácticamente durante el entrenamiento']
  }, {
    id: 5,
    icon: '📋',
    color: 'bg-teal-500',
    border: 'border-teal-500',
    lightBg: 'bg-teal-50',
    title: 'Sesiones Listas para Usar',
    subtitle: '+60 sesiones completas organizadas por objetivo',
    description: 'Abrís el PDF, elegís la sesión del día y entrás al campo con todo pensado. Así de simple.',
    bullets: ['Sesiones de pretemporada, competencia y descarga', 'Sesiones técnico-tácticas por posición', 'Sesiones de transición y juego reducido', 'Sesiones para planteles con poco tiempo de entrenamiento semanal', 'Formato listo para imprimir o usar en tablet', 'Cómo modificar cada sesión según el nivel del grupo', 'Sesiones para trabajar sin arquera o con plantel incompleto', 'Sesiones de recuperación y descarga post-partido']
  }, {
    id: 6,
    icon: '⭐',
    color: 'bg-yellow-500',
    border: 'border-yellow-500',
    lightBg: 'bg-yellow-50',
    title: 'Liderazgo y Gestión de Equipo',
    subtitle: 'El lado humano que ningún curso te enseña',
    description: 'Saber de fútbol no alcanza. Este tomo te convierte en el entrenador/a que cada equipo necesita.',
    bullets: ['Cómo liderar un grupo femenino con autoridad y empatía', 'Gestión de conflictos dentro del plantel', 'Comunicación efectiva en el vestuario y en el campo', 'Cómo motivar jugadoras en momentos de crisis', 'Charlas técnicas que generan impacto real', 'Cómo construir identidad y cultura de equipo', 'Manejo de egos, jerarquías y capitanas', 'Comunicación con dirigentes, padres y familias']
  }];
  return <section className="py-8 md:py-20 px-3 md:px-4 bg-gray-50" data-id="element-328">
      <div className="max-w-6xl mx-auto" data-id="element-329">
        <div className="text-center mb-5 md:mb-16" data-id="element-330">
          <h2 className="text-2xl md:text-5xl font-black text-navy mb-2 md:mb-4" data-id="element-331">
            LOS 6 TOMOS
          </h2>
          <p className="text-sm md:text-xl text-gray-600 font-medium max-w-2xl mx-auto" data-id="element-332">
            Seis manuales prácticos diseñados para entrenadores de fútbol
            femenino de todos los niveles y enfoques.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-8" data-id="element-333">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-white rounded-xl md:rounded-2xl border-l-4 md:border-l-8 ${tomo.border} shadow-md hover:shadow-xl transition-all duration-300 flex flex-col overflow-hidden`} data-id="element-334">
              <div className="p-3 md:p-8 flex-grow" data-id="element-335">
                <div className="flex items-start gap-3 md:gap-6 mb-2 md:mb-6" data-id="element-336">
                  <div className={`w-10 h-10 md:w-20 md:h-20 rounded-xl md:rounded-2xl ${tomo.lightBg} flex items-center justify-center text-xl md:text-4xl flex-shrink-0 shadow-inner`} data-id="element-337">
                    {tomo.icon}
                  </div>
                  <div data-id="element-338">
                    <div className="mb-1 md:mb-2" data-id="element-339">
                      <span className={`inline-block text-[10px] md:text-sm font-black text-white px-2 md:px-3 py-0.5 md:py-1 rounded-md ${tomo.color} shadow-sm`} data-id="element-340">
                        TOMO {tomo.id}
                      </span>
                    </div>
                    <h3 className="text-base md:text-2xl font-black text-navy leading-tight mb-0.5 md:mb-1" data-id="element-341">
                      {tomo.title}
                    </h3>
                    <p className="text-xs md:text-base font-bold text-brandGreen" data-id="element-342">
                      {tomo.subtitle}
                    </p>
                  </div>
                </div>
                <p className="text-gray-600 text-xs md:text-base leading-relaxed bg-gray-50 p-2.5 md:p-4 rounded-lg md:rounded-xl border border-gray-100" data-id="element-343">
                  {tomo.description}
                </p>
              </div>

              <div className="border-t border-gray-100 bg-white" data-id="element-344">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-3 md:px-8 py-2.5 md:py-4 flex items-center justify-between text-xs md:text-base font-bold text-gray-600 hover:text-brandGreen hover:bg-gray-50 transition-colors focus:outline-none" data-id="element-345">
                  <span className="flex items-center gap-2" data-id="element-346">
                    Ver temario completo
                  </span>
                  <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 transition-transform duration-300 ${openIndex === index ? 'rotate-180 text-brandGreen' : ''}`} data-id="element-347" />
                </button>

                <AnimatePresence data-id="element-348">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-349">
                      <div className="px-3 md:px-8 pb-4 md:pb-6 pt-1 md:pt-2 bg-gray-50 border-t border-gray-100" data-id="element-350">
                        <ul className="space-y-2 md:space-y-3" data-id="element-351">
                          {tomo.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2 md:gap-3" data-id="element-352">
                              <CheckCircle2 className={`w-4 h-4 md:w-5 md:h-5 ${tomo.color.replace('bg-', 'text-')} flex-shrink-0 mt-0.5`} data-id="element-353" />
                              <span className="text-gray-700 text-xs md:text-base font-medium" data-id="element-354">
                                {bullet}
                              </span>
                            </li>)}
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}